import fetch from 'axios';

import config from '@dragonfruit/config';

const { SLACK_WEBHOOK, SNAPASK_SITE_ENDPOINT } = config;

export const sendMessage = ({
  error: { message, stack },
  info: { locale, url, userId } = {},
}) => {
  if (!SLACK_WEBHOOK) {
    return;
  }

  const payload = {
    // use site_endpoint be the name in slack
    username: SNAPASK_SITE_ENDPOINT,
    icon_emoji: ':skull_and_crossbones:',
    text: `*locale*: ${locale}\r\n*url*: ${url}\r\n*userId*: ${userId}`,
    attachments: [
      {
        title: message,
        text: stack && `\`\`\`${stack}\`\`\``,
        color: 'danger',
        footer: 'web-error',
      },
    ],
  };

  fetch(SLACK_WEBHOOK, {
    method: 'POST',
    data: payload,
    headers: {
      // slack api not accept application/json
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};



// WEBPACK FOOTER //
// ./app/services/message.js